import React, { useState } from 'react';
import { ChevronDown, CreditCard, ShoppingCart, Truck, Clock, HelpCircle, MessageCircle } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
  icon: React.ReactNode;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs: FAQItem[] = [{
    icon: <CreditCard className="w-5 h-5 text-alphaGold" data-id="element-108" data-mp="2bmgpqb11cxdt" />,
    question: '¿Cuáles son los métodos de pago?',
    answer: 'Aceptamos transferencia bancaria, Mercado Pago o efectivo al momento de la entrega. Elegí el método que te resulte más cómodo al hacer tu pedido por WhatsApp.'
  }, {
    icon: <ShoppingCart className="w-5 h-5 text-alphaGold" data-id="element-109" data-mp="26ravmoxhccen" />,
    question: '¿Cómo hacer tu pedido?',
    answer: 'Es muy simple: elegí el producto que querés, hacé click en "Pedir por WhatsApp" y te respondemos al instante. Confirmamos stock, coordinamos el pago y la entrega. ¡Listo!'
  }, {
    icon: <Truck className="w-5 h-5 text-alphaGold" data-id="element-110" data-mp="1rofstcqe95o8" />,
    question: '¿Cuánto tarda el envío?',
    answer: 'Los envíos dentro de Montevideo se realizan en 24 a 48 horas hábiles luego de confirmado el pago. También podés coordinar un Pick Up en Malvín para retirarlo el mismo día.'
  }, {
    icon: <Clock className="w-5 h-5 text-alphaGold" data-id="element-111" data-mp="2fd8s9j685vnl" />,
    question: '¿Cuál es el horario de atención?',
    answer: 'Atendemos de Lunes a Sábados de 10:00 a 18:00 horas. Por WhatsApp podés escribirnos en cualquier momento y te respondemos a la brevedad.'
  }, {
    icon: <HelpCircle className="w-5 h-5 text-alphaGold" data-id="element-112" data-mp="2jfc4ia0px49x" />,
    question: '¿Los productos son originales?',
    answer: 'Sí, todos nuestros productos son 100% originales. Trabajamos directamente con marcas como Cibeles y Profit, garantizando autenticidad y calidad en cada suplemento.'
  }, {
    icon: <MessageCircle className="w-5 h-5 text-alphaGold" data-id="element-113" data-mp="2p43pe67lo1vq" />,
    question: '¿Puedo recibir asesoramiento sobre qué suplemento elegir?',
    answer: 'Por supuesto. Escribinos por WhatsApp contándonos tu objetivo (ganar masa, definir, mejorar rendimiento, etc.) y te recomendamos el suplemento ideal para vos.'
  }];
  return <section className="bg-dark-900 py-[80px] px-5" id="faq" data-id="element-114" data-mp="334wm8xldj920">
      <div className="max-w-[800px] mx-auto" data-id="element-115" data-mp="382y3re35j0bd">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-116" data-mp="3826bod8rjkpu">
          Preguntas Frecuentes
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-117" data-mp="3hrpw3nc4jmmt">
          Todo lo que necesitás saber antes de hacer tu pedido
        </p>

        <div className="space-y-3" data-id="element-118" data-mp="3mqj6h6w46xir">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-600 border border-dark-300 rounded-lg overflow-hidden transition-colors duration-300 hover:border-alphaGold/50" data-id="element-119" data-mp="3qu8spppbh30m" data-mpi={index}>
              <button onClick={() => toggle(index)} className="w-full flex items-center gap-3 p-5 text-left bg-transparent border-none cursor-pointer" data-id="element-120" data-mp="1k5gpd45x5ayf">
                {faq.icon}
                <span className="flex-1 text-white font-bold text-[0.95rem]" data-id="element-121" data-mp="1b63ce1il648y">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-alphaGold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-122" data-mp="22vol317agz4l" />
              </button>
              {openIndex === index && <div className="px-5 pb-5 pt-0" data-id="element-123" data-mp="1u0qo9j10t27z">
                  <div className="border-t border-dark-300 pt-4 ml-8" data-id="element-124" data-mp="1p4js2hyff538">
                    <p className="text-[#aaa] text-[0.9rem] leading-[1.7]" data-id="element-125" data-mp="2mj5skvgrwrsl">
                      {faq.answer}
                    </p>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}